import { ModalContext } from 'app/app';
import { FieldInput } from 'components/fieldInput';
import { Form, Formik } from 'formik';
import { Fragment, useContext, useState } from 'react';
import * as Yup from 'yup';
import image from './images/loader.gif';
import styles from './styles.module.scss';
import axios from 'axios';
import { ViewContext } from 'components/lib';
import QuoteUtils from 'helpers/quoteUtils';

const quoteUtils = new QuoteUtils();

export function EmailQuoteModal() {
  const view = useContext(ViewContext);
  const { modal, setModal } = useContext(ModalContext);
  const [loading, setLoading] = useState(false);

  if (!modal.data?.data) {
    return null;
  }

  async function sendPDFEmail(emails) {
    const quotePDFBlob = await quoteUtils.generateQuotePDFBlob(modal.data.data);
    const submissionNumber =
      modal.data?.submission_number ??
      modal.data?.data?.submission_number ??
      modal.data?.data?.quote?.submission_number ??
      modal.data?.data?.quote?.submissionNumber;
    const companyName =
      modal.data?.company_name ??
      modal.data?.data?.company_name ??
      modal.data?.data?.quote?.company_name ??
      modal.data?.data?.quote?.companyName;

    const formData = new FormData();
    formData.append('file', quotePDFBlob, `data?.pdf`);

    const file = await axios.post('/api/quote/file', formData);

    if (submissionNumber && companyName) {
      await axios
        .post(`/api/quote/pdf`, {
          link: file.data.link,
          submission_number: submissionNumber,
          company_name: companyName,
          emails: Array.isArray(emails) ? emails : [emails],
        })
        .then((res) => {
          setModal({});
          console.log('sendPDFEmail response', res.data);

          view.notification.show(
            'Email sent.',
            'success',
            true,
            'toast',
            'check-circle'
          );
        })
        .catch((err) => {
          console.log(err);
          setModal({});
        });
    } else {
      view.notification.show(
        'Missing company name or submission number; cannot send email.',
        'error',
        true,
        'toast',
        'x-circle'
      );
      setModal({});
    }
  }

  return (
    <Fragment>
      {modal.name === 'email_quote_modal' && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.insideWrapper}>
              <div className={styles.title}>Send via Email</div>
              <div className={styles.line} />
              <Formik
                validationSchema={Yup.object().shape({
                  emails: Yup.string()
                    .email('Invalid email!')
                    .required('Field required!'),
                })}
                initialValues={{
                  emails: '',
                }}
                onSubmit={async (values) => {
                  setLoading(true);
                  await sendPDFEmail(values.emails);
                  setLoading(false);
                }}
              >
                {({
                  errors,
                  touched,
                  handleSubmit,
                  handleChange,
                  handleBlur,
                }) => (
                  <Form className={styles.form} onSubmit={handleSubmit}>
                    <div className={styles.fieldRow}>
                      <FieldInput
                        id="emails"
                        name="emails"
                        type="text"
                        label="Emails"
                        placeholder="Emails"
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        showErrors
                        errors={errors.emails}
                        touched={touched.emails}
                        required
                      />
                    </div>
                    <div className={styles.footer}>
                      <div className={styles.buttons}>
                        <button
                          className={styles.cancel}
                          onClick={() => {
                            setModal({});
                            setLoading(false);
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          className={styles.save}
                          type="submit"
                          style={
                            !loading
                              ? { cursor: 'pointer' }
                              : { cursor: 'default' }
                          }
                        >
                          {loading ? (
                            <img
                              src={image}
                              alt="loading"
                              style={{ width: '25px' }}
                            />
                          ) : (
                            'Send'
                          )}
                        </button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};
